module.exports = __webpack_public_path__ + "img/caselist12.dceb1573.jpg";